import {connect} from 'react-redux'
import {ViewerHeader} from 'report-components'
import {isUploadingKeyImages, getPatientName} from 'report-components/lib/selectors'
import {postFetcher} from 'startlibs'
import {ReportInfoCard} from '../dashboard/ReportInfoCard'
import React from 'react'

export const sendEmailFetcher = (reportUid) => (data) => postFetcher("/api/share-report/"+reportUid,data)

const getInfo = (basicInfo,dicomInfo) => (key) => basicInfo.filter(_=>_.dicomField === key).map(_=>_.value)[0] || dicomInfo[key]
const translateReportPropsToInfoCard = ({lastSaved,finished,dicomInfo,reportBasicInfos}) => {
  const getKey = getInfo(Object.values(reportBasicInfos),dicomInfo)
  return {
    lastSaved,
    finished,
    studydate: getKey('studydate'),
    patientName: getKey('patientname'),
    studydesc: getKey('studydesc'),
    refphysician: getKey('refphysician')
  }
}

export const ReportViewerHeader = connect(({report}) => ({
  reportRecipients: report.reportRecipients,
  reportInfoCard: <ReportInfoCard report={translateReportPropsToInfoCard(report)}/>,
  renderEndPoint: report.pdfrenderer.reportRendererEndpoint,
  loaderEndPoint: report.pdfrenderer.reportLoaderEnpoint,
  userEmail: report.userEmail,
  reportFinished: report.finished,
  lastSaved: report.lastSaved,
  reportUID: report.reportUID,
  attachedReport: true,
  isUploadingKeyImages: isUploadingKeyImages(report.reportKeyImages),
  language: report.reportSettings.layout.language,
  dateFormat: report.reportSettings.layout.dateFormat,
  studies: report.dicomInfo.studies,
  readOnly: report.readOnly,
  patientName: getPatientName(report),
  sendEmailFetcher: sendEmailFetcher(report.reportUID)
}))(ViewerHeader)




// WEBPACK FOOTER //
// ./src/javascripts/report/ReportViewerHeader.jsx